module.exports = __webpack_public_path__ + "img/store_active.2309b47e.png";